"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateObject = void 0;
exports.validateObject = function (fn) { return function (item) {
    return !Object.keys(item).some(function (x) { return !fn(x, item); });
}; };
